import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/siteContent";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 sm:py-32 border-t border-[#E5E7EB] bg-[#F9FAFB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-[#6B7280] mb-6">
              Questions
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight leading-tight text-[#0F2A44]">
              Common questions,
              <br />
              <span className="italic">straight answers.</span>
            </h2>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, idx) => (
                <AccordionItem
                  key={idx}
                  value={`faq-${idx}`}
                  data-testid="faq-accordion-item"
                  className="border-b border-[#E5E7EB] last:border-b-0"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${idx}`}
                    className="text-left font-serif text-lg sm:text-xl text-[#0F2A44] hover:text-[#D4AF7F] hover:no-underline py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#1A1A1A]/75 leading-relaxed text-base pb-6 pr-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
